import { FaUserTie, FaBriefcase } from "react-icons/fa";

/**
 * Single source of truth for Contex purchasable products.
 */
export const PRODUCTS = {
  basic: {
    id: "basic",
    productType: "plan",
    purchaseType: "basic",
    price: 10,
    title: "Elaboración de anexo de gastos personales",
    shortTitle: "Plan Básico",
    reference: "ConTex: Elaboración anexo de gastos personales",
    color: "green",
    accent: "#22c55e",
    icon: FaUserTie,
    scope: "profile",
    features: [
      "Anexo de gastos personales",
      "Categorización de compras",
      "Sincronización SRI básica",
      "Soporte por correo",
    ],
  },
  premium: {
    id: "premium",
    productType: "plan",
    purchaseType: "premium",
    price: 25,
    title: "Trabajo bajo relación de dependencia",
    shortTitle: "Plan Completo",
    reference: "ConTex: Trabajo bajo relación de dependencia",
    color: "blue",
    accent: "#3b82f6",
    icon: FaBriefcase,
    scope: "profile",
    features: [
      "Todo lo del plan básico",
      "Ingresos y roles de pago",
      "Proyección del impuesto a la renta",
      "Deducciones y cargas familiares",
      "Soporte prioritario",
    ],
  },
};

export const getProduct = (id) => PRODUCTS[id] || null;

export const formatPrice = (amount) =>
  `$${Number(amount || 0).toFixed(2)}`;

export default PRODUCTS;
